import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatebushirehadapsar() {



  const cardData =
  {
    keyword: 'Corporate Bus Hire Hadapsar Pune',
    heading: 'Sanavi Travels: Corporate Bus Hire Hadapsar Pune',
    headingDescription: 'Sanavi Travels offers reliable Corporate Bus Hire in Hadapsar Pune, providing safe, comfortable, and professional transportation for corporate events, office outings, team-building trips, conferences, and business travel. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth rides, and a hassle-free travel experience. With experienced drivers, flexible full-day and hourly corporate bus packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Hadapsar, Pune, and nearby areas, making it ideal for office commutes, client visits, corporate events, and team trips. Choose Sanavi Travels for trusted corporate bus hire services in Hadapsar Pune, delivering comfort, safety, and seamless transportation for every business requirement.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,



"services": [
  {
    "name": "Corporate Bus Hire Hadapsar Pune",
    "description": "Corporate Bus Hire in Hadapsar Pune provides reliable and comfortable transportation for businesses, IT companies, and corporate events. Designed to meet professional travel needs, the service ensures punctual pickups, well-maintained buses, and experienced drivers, making group travel smooth and stress-free."
  },
  {
    "name": "Corporate Bus Rental Hadapsar",
    "description": "Corporate Bus Rental in Hadapsar offers flexible rental options for office staff transportation, corporate outings, conferences, and business trips. With a focus on safety, comfort, and timely service, it allows companies to efficiently manage employee commutes and corporate travel requirements."
  },
  {
    "name": "AC Corporate Bus Hadapsar",
    "description": "AC Corporate Bus in Hadapsar provides air-conditioned luxury travel for employees, executives, and corporate groups. Ideal for summer travel and long-distance trips, it ensures a comfortable and refreshing experience with spacious seating and professional chauffeurs."
  },
  {
    "name": "Employee Transport Bus Hadapsar",
    "description": "Employee Transport Bus Hadapsar is designed to facilitate hassle-free daily commutes and corporate trips. The service emphasizes punctuality, safety, and convenience, ensuring that employees reach office or events on time while traveling comfortably in well-maintained buses."
  },
  {
    "name": "Office Staff Bus Hadapsar",
    "description": "Office Staff Bus Hadapsar offers organized transportation solutions for corporate staff, including daily office commutes, team outings, and business travel. Equipped with reliable buses and professional drivers, it ensures seamless travel for employees across Hadapsar and Pune."
  },
  {
    "name": "Affordable Corporate Bus Hadapsar",
    "description": "Affordable Corporate Bus Hadapsar provides budget-friendly options for group corporate travel without compromising on comfort or quality. Ideal for small to large organizations, the service combines reliable vehicles, professional drivers, and cost-effective rental plans."
  },
  {
    "name": "Chauffeur Driven Corporate Bus",
    "description": "Chauffeur Driven Corporate Bus ensures a stress-free travel experience with professional drivers handling navigation, traffic, and schedules. Perfect for executive transport, corporate events, and team outings, the service prioritizes safety, comfort, and punctuality."
  },
  {
    "name": "Best Corporate Bus Hadapsar",
    "description": "Best Corporate Bus Hadapsar guarantees high-quality group travel with emphasis on reliability, comfort, and professional service. Offering AC and non-AC options, chauffeur-driven buses, and well-maintained vehicles, it is ideal for corporate clients, IT companies, and business events."
  },
  {
    "name": "IT Company Bus Hadapsar",
    "description": "IT Company Bus Hadapsar caters specifically to IT firms and corporate offices, providing scheduled transport for employees and clients. The service ensures timely pickups, spacious and comfortable buses, and professional drivers to meet the dynamic travel needs of tech professionals."
  },
  {
    "name": "Business Travel Bus Pune",
    "description": "Business Travel Bus Pune offers efficient and comfortable transportation for corporate trips, conferences, seminars, and client meetings. With modern buses, AC options, and experienced drivers, it ensures professional and stress-free travel for business groups across Pune."
  },
  {
    "name": "Online Bus Booking Hadapsar",
    "description": "Online Bus Booking Hadapsar allows companies and individuals to reserve corporate buses conveniently via an easy-to-use online platform. With instant confirmation, flexible scheduling, and multiple bus options, it simplifies the planning of corporate travel and events."
  },
  {
    "name": "Event Corporate Bus",
    "description": "Event Corporate Bus provides seamless group transportation for conferences, seminars, product launches, and corporate gatherings. The service ensures punctual arrivals, comfortable seating, and professional drivers, making it ideal for large-scale corporate events."
  },
  {
    "name": "Group Travel Corporate Bus",
    "description": "Group Travel Corporate Bus facilitates travel for teams, employees, and business groups. With spacious seating, safety measures, and chauffeur-driven service, it ensures a smooth, reliable, and efficient travel experience for corporate outings, offsites, and client visits."
  },
  {
    "name": "Hadapsar Corporate Transport",
    "description": "Hadapsar Corporate Transport provides specialized transportation solutions for businesses in Hadapsar and Pune. From daily employee commutes to event transport, the service focuses on punctuality, comfort, and reliability, ensuring efficient corporate mobility."
  },
  {
    "name": "Pune Corporate Bus",
    "description": "Pune Corporate Bus offers professional and comfortable group travel solutions across Pune. Catering to offices, IT companies, and business clients, it provides AC and non-AC buses, chauffeur-driven service, and flexible rental options for corporate and business travel needs."
  }
],
"tableData": [
  ["Corporate Bus Hire Hadapsar Pune", "Corporate Bus Rental Hadapsar"],
  ["AC Corporate Bus Hadapsar", "Employee Transport Bus Hadapsar"],
  ["Office Staff Bus Hadapsar", "Affordable Corporate Bus Hadapsar"],
  ["Chauffeur Driven Corporate Bus", "Best Corporate Bus Hadapsar"],
  ["IT Company Bus Hadapsar", "Business Travel Bus Pune"],
  ["Online Bus Booking Hadapsar", "Event Corporate Bus"],
  ["Group Travel Corporate Bus", "Hadapsar Corporate Transport"],
  ["Pune Corporate Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Corporate Bus Hire Hadapsar Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers professional and dependable corporate bus hire services in Hadapsar, Pune, perfect for employee transportation, corporate events, business outings, and client transfers."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our corporate buses are air‑conditioned, clean, and regularly serviced to ensure a comfortable and smooth travel experience for your team."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and trained to handle corporate transportation needs with professionalism and safety."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for corporate bus hire in Hadapsar Pune, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, route scheduling, and any changes to your corporate travel plans."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized corporate bus hire packages tailored to your business requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All corporate buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic experience for passengers."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for corporate bus hire in Hadapsar Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide corporate bus hire services in Hadapsar Pune?',
    answer: 'Yes, Sanavi Travels offers professional corporate bus hire solutions in Hadapsar Pune for employee transport, corporate events, and business outings.'
  },
  {
    question: 'How can I book a corporate bus in Hadapsar Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for corporate hire?',
    answer: 'Sanavi Travels provides air‑conditioned, spacious, and well‑maintained buses suitable for corporate travel.'
  },
  {
    question: 'Are the drivers experienced for corporate travel?',
    answer: 'Yes, our drivers are professional, licensed, and experienced in handling corporate travel schedules and routes.'
  },
  {
    question: 'Can I hire a corporate bus for a few hours or a whole day?',
    answer: 'Yes, we offer hourly, half‑day, full‑day, and customized corporate bus hire packages.'
  },
  {
    question: 'Is the corporate bus service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round‑the‑clock support for corporate bus hire services in Hadapsar Pune.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all corporate buses are thoroughly cleaned and sanitized before every trip.'
  },
  {
    question: 'What payment options are available for corporate bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your corporate bus hire trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kulkarni',
    feedback: 'Hired a corporate bus for our office event in Hadapsar Pune. Excellent service, punctual drivers, and comfortable ride.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ananya Joshi',
    feedback: 'Sanavi Travels provided reliable corporate bus hire service. Professional staff and smooth travel experience.',
    rating: 5
  }
];































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Bus Hire Hadapsar Pune - Sanavi Travels",
  "description": "Hire corporate buses in Hadapsar Pune with Sanavi Travels. AC, chauffeur-driven buses available for employee transport, office staff, IT companies, business travel, events, and group corporate trips. Affordable rates with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "75"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Corporate Bus Hire Hadapsar Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire corporate buses in Hadapsar Pune with Sanavi Travels. AC, chauffeur-driven buses available for employee transport, office staff, IT companies, business travel, events, and group corporate trips. Affordable rates with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/117.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatebushirehadapsar;